module.exports = __webpack_public_path__ + "static/media/verdeGun_wide.2eb9e385.jpg";